//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'jud_playground',
    colors: ['#f04924', '#fcce09', '#408ac9'],
    stroke: '#2e2925',
    background: '#ffffff',
    type: 'judson',
  },
  {
    name: 'jud_horizon',
    colors: ['#f8c3df', '#f2e420', '#28b3d0', '#648731', '#ef6a7d'],
    stroke: '#030305',
    background: '#f2f0e1',
    type: 'judson',
  },
  {
    name: 'jud_mural',
    colors: ['#ca3122', '#e5af16', '#4a93a2', '#0e7e39', '#e2b9bd'],
    stroke: '#1c1616',
    background: '#e3ded8',
    type: 'judson',
  },
  {
    name: 'jud_cabinet',
    colors: ['#f0afb7', '#f6bc12', '#1477bb', '#41bb9b'],
    stroke: '#020508',
    background: '#e3ded8',
    type: 'judson',
  },
];
